import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { FormTextField } from 'src/components/Forms';
import { GenericForm } from 'src/components/GenericForm/generic-form';
import { ModalContainer } from 'src/components/ModalContainer';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { useCopyToClipboard } from 'src/utils/hooks';

enum CopyTextFormField {
  Text = 'text',
}

interface CopyTextFormValues {
  [CopyTextFormField.Text]: string;
}

export const CopyTextModal = () => {
  const { closeModal } = useModalMethods(Modals.CopyText);
  const { modalProps } = useModalState(Modals.CopyText);
  const { copyToClipboard } = useCopyToClipboard();

  const { text = '', title = 'Copy Text', onSuccess } = modalProps || {};
  const formMethods = useForm<CopyTextFormValues>({
    defaultValues: { [CopyTextFormField.Text]: text },
  });

  const handleCopy = useCallback(async () => {
    try {
      await copyToClipboard(text);
      onSuccess?.();
    } catch (err) {
      console.error('Clipboard copy failed', err);
    }
    closeModal();
  }, [closeModal, copyToClipboard, text, onSuccess]);

  return (
    <ModalContainer
      open
      size="small"
      title={title}
      actions={[
        {
          label: 'Copy',
          kind: 'primary',
          onClick: handleCopy,
          disabled: !text,
          testId: 'copy-text-submit',
        },
      ]}
      onClose={closeModal}
      data-testid="copy-text-modal"
    >
      <GenericForm<CopyTextFormValues> formMethods={formMethods}>
        <FormTextField
          type="textfield"
          name={CopyTextFormField.Text}
          label="Text"
          textFieldProps={{
            InputProps: { readOnly: true },
            inputProps: { 'data-testid': 'copy-text-input' },
          }}
        />
      </GenericForm>
    </ModalContainer>
  );
};
